import * as React from 'react';
import { css } from 'styled-components';
import { checkValue } from 'src/components/common/helper';

// Module Context
import { useComponentContext } from 'src/components/common/modules/component-layout/component-context';

// Components
import Layout from 'src/components/common/theme/Layout';
import { ModuleProps } from 'src/components/common/module-util';
import { FigureComponent, Typo } from 'src/components/common/ui';
import { getDeviceImage } from 'src/components/common/theme/component';
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';
import { UitkFigureAspectRatioType } from 'uitk-react-images';

const ImageCard = (props: any) => {
  const {
    image,
    turnOffGradient,
    uniquekey,

  } = props;
  const { width: windowWidth } = useWindowDimensions();

  let windowSize = '';
  if (windowWidth > 920) windowSize = 'desktop';
  else if (windowWidth > 575) windowSize = 'tablet';
  else windowSize = 'mobile';

  // Dynamic style overrides
  const moduleCss = () => {
    return ` `;
  };

  const figureProps = {
    src:checkValue(image) ? getDeviceImage(image, windowSize) : 'https://mesocp3.azureedge.net/media/c32fmcus/static-img.jpg',
    exClass: 'three-card-image-item--image',
    alt: '',
    copyRightProps: {},
    isGradientActive: turnOffGradient !== 'True',
    imageRatio: UitkFigureAspectRatioType.R16_9,
  };

  return (
    <>
      <FigureComponent key={uniquekey} {...figureProps} />
    </>
  );
};

export default ImageCard;
